"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CathAllTrekkerEvent = exports.CathAllTrekkerEventType = exports.PrivateTrekkerEvent = void 0;
const tslib_1 = require("tslib");
const structured_clone_1 = (0, tslib_1.__importDefault)(require("@ungap/structured-clone"));
class PrivateTrekkerEvent extends CustomEvent {
    constructor(name, context) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        super(name, context);
        this._eventName = name;
        this._context = context;
    }
    get context() {
        return this._context;
    }
    get eventName() {
        return this._eventName;
    }
    clone() {
        return new PrivateTrekkerEvent(this.eventName, (0, structured_clone_1.default)(this.context));
    }
}
exports.PrivateTrekkerEvent = PrivateTrekkerEvent;
exports.CathAllTrekkerEventType = "CathAllTrekkerEvent";
class CathAllTrekkerEvent extends CustomEvent {
    constructor(evt) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        super(exports.CathAllTrekkerEventType, evt);
        this._wrapped = evt;
    }
    get wrapped() {
        return this._wrapped;
    }
    get eventName() {
        return this._wrapped.eventName;
    }
    get context() {
        return this._wrapped.context;
    }
}
exports.CathAllTrekkerEvent = CathAllTrekkerEvent;
//# sourceMappingURL=types.js.map